import { memo } from "react";
import { cn } from "@discovery/classnames";
import * as M from "@discovery/prelude/lib/data/maybe";
import { pushModuleLinkTracking } from "@discovery/common-dplus/lib/adobe";
import { PlaceholderImage } from "../../../../atoms/placeholder-image";
import { Link } from "../../../../atoms/link";
import { getIsMobile } from "../../../../../utils/isMobile";
import { Icon, Icons } from "../../../../atoms/icon";
import { SonicImageDplus } from "../../../../atoms/sonic-image";
import { Typography, HeaderVariants, Tags } from "../../../../atoms/typography";
import { Favorite } from "../../../../molecules/favorites";
import Strings from "../../../../../utils/hardcoded.json";
import * as styles from "./styles.css";
import { useUser } from "../../../../../utils/hooks";
import { config } from "@discovery/common-dplus/lib/utils/config-types";
const HoverOverLay = ({ description, isFavorite, id, route, webAuthRedirectionUrl, read, category, showGenre, name, contentGenre, }) => {
    const { isAnonymous } = useUser();
    return (React.createElement("div", { className: styles.portaraitHoverOverlay },
        React.createElement("div", { className: styles.content },
            React.createElement("div", { className: styles.basicHoverPlayIconWrapper, id: "#play-icon" },
                React.createElement(Icon, { type: Icons.HoverPlayIcon, className: styles.basiCardhoverPlayIcon })),
            React.createElement(React.Fragment, null,
                React.createElement("div", { className: styles.baicHoverContent },
                    React.createElement(Typography, { variant: HeaderVariants.headingSix, tag: Tags.h6, classNameM: M.of(styles.basicShowName) },
                        React.createElement(React.Fragment, null, name)),
                    React.createElement("div", { className: styles.basicDescwrapper },
                        React.createElement(Typography, { variant: HeaderVariants.subHeadTwo, tag: Tags.span, classNameM: M.of(styles.basicShowDesc) },
                            React.createElement(React.Fragment, null, description)),
                        React.createElement("div", { className: styles.likeButton, id: isFavorite ? Strings.LIKE : Strings.UNLIKE },
                            React.createElement(Favorite, { read: read, id: id, isFavorite: isFavorite, anonymous: isAnonymous, type: category, webAuthUrl: webAuthRedirectionUrl, route: route, contentGenre: contentGenre, showGenre: showGenre, name: name }))))))));
};
const NewEpisodes = () => (React.createElement("div", { className: styles.newEpisodeContainer },
    React.createElement("span", { className: styles.Episodes }, Strings.NEW_EPISODES)));
export const KidsOverLayTheme = ({ isFavorite, id, webAuthRedirectionUrl, read, route, category, }) => {
    const { isAnonymous } = useUser();
    return (React.createElement("div", { className: styles.portaraitHoverOverlay },
        React.createElement("div", { className: styles.kidscontentWrapper },
            React.createElement("div", { className: styles.kidsIconWarpper },
                React.createElement("div", { className: styles.kidsPlayIconWrapper },
                    React.createElement(Icon, { type: Icons.HoverPlayIcon, className: styles.kidsPlayIcon }),
                    React.createElement("span", { className: styles.kidPlayText }, "Play")),
                React.createElement("div", { className: styles.likeButton, id: isFavorite ? Strings.LIKE : Strings.UNLIKE },
                    React.createElement(Favorite, { read: read, id: id, isFavorite: isFavorite, anonymous: isAnonymous, type: category, webAuthUrl: webAuthRedirectionUrl, route: route }))))));
};
export const PosterCard = memo(({ posterImageM = M.empty(), route, ageConstraint = 0, packages, minimumAgeM = M.empty(), isNewEpisodeM = M.empty(), isViewAll, name, id, category = "", descriptionM = M.empty(), isFavoriteM = M.empty(), webAuthRedirectionUrl, read, index, genre, contentGenre, }) => {
    const { premiumPackagesM } = useUser();
    const image = posterImageM &&
        M.fromMaybe(posterImageM, {});
    const premiumPackages = M.fromMaybe(premiumPackagesM, []);
    const isFavorite = M.fromMaybe(isFavoriteM, false);
    const isPremium = premiumPackages.includes(packages);
    const minimumAge = M.fromMaybe(minimumAgeM, 0);
    const isContentAccessible = minimumAge >= ageConstraint;
    const showViewAll = isViewAll ? true : false;
    const sendAndalyticsEvents = () => {
        const linkPosition = index && index + 1;
        category &&
            linkPosition &&
            pushModuleLinkTracking(config.standardPageRouteFragments.home, linkPosition.toString(), name, category, "www.discoveryplus.in" + config.standardPageRouteFragments.home, route);
    };
    const description = M.fromMaybe(descriptionM, "");
    const isNewEpisode = M.fromMaybe(isNewEpisodeM, false);
    const DesktopView = () => {
        return (React.createElement("div", { className: styles.thumbnailPortaitImageContainer },
            React.createElement("div", { className: styles.thumbnailPortraitImageWrapper },
                isPremium && (React.createElement(Icon, { type: Icons.PremiumMemberIcon, className: styles.premiumIcon })),
                isContentAccessible && (React.createElement(Icon, { type: Icons.Plus18Tag, className: styles.ageConstraints })),
                React.createElement(PlaceholderImage, null),
                React.createElement(SonicImageDplus, { src: image.src, quality: 75, className: styles.thumbnailImage, width: 214 }),
                isNewEpisode && React.createElement(NewEpisodes, null))));
    };
    const MobileView = () => {
        return (React.createElement(React.Fragment, null,
            isPremium && (React.createElement(Icon, { type: Icons.PremiumMemberIcon, className: styles.premiumIcon })),
            isContentAccessible && (React.createElement(Icon, { type: Icons.Plus18Tag, className: styles.ageConstraints })),
            React.createElement(PlaceholderImage, null),
            React.createElement(SonicImageDplus, { src: image.src, quality: 75, className: cn(styles.portraitImg, {
                    [styles.viewAllPoster]: showViewAll,
                }), width: showViewAll ? 145 : 105 }),
            isNewEpisode && React.createElement(NewEpisodes, null)));
    };
    //TODO: Do the same for mobile
    const Overlay = () => {
        // switch (theme) {
        //   case THEME.KIDS:
        //     return (
        //       <KidsOverLayTheme
        //         description={description}
        //         isFavorite={isFavorite}
        //         id={id}
        //         category={category}
        //         webAuthRedirectionUrl={webAuthRedirectionUrl}
        //         read={read}
        //         route={route}
        //       />
        //     );
        //   default:
        return (React.createElement(HoverOverLay, { description: description, isFavorite: isFavorite, id: id, category: category, webAuthRedirectionUrl: webAuthRedirectionUrl, read: read, route: route, showGenre: genre, name: name, contentGenre: contentGenre }));
        // }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.categoryWrapper, onClick: sendAndalyticsEvents, id: "#posterCardD" },
            React.createElement(Link, { href: route },
                React.createElement("div", { className: cn(styles.thumbnailPortraitContainer, {
                        [styles.hoverable]: !getIsMobile(),
                    }) },
                    React.createElement(Overlay, null),
                    React.createElement(DesktopView, null)))),
        React.createElement("div", { className: cn(styles.potraitContainer, {
                [styles.viewAllPoster]: showViewAll,
            }), id: "#posterCardM" },
            React.createElement(Link, { href: route },
                React.createElement(MobileView, null)))));
});

